import { useNavigate } from "react-router-dom";
import useRedirect from "@/hooks/useRedirect";
import useCybersourceService from "@/hooks/useCybersourceService";
import { useCallback, useEffect, useMemo, useState } from "react";
import useCheckoutCardForm from "../hooks/useCheckoutCardForm";
import CheckoutCardView from "./view";
import useCaptcha from "@/hooks/useCaptcha";
import { useSingleFlag } from "@/hooks/useFlags";

export default function CheckoutCard() {
  useRedirect("checkout/card");
  const navigate = useNavigate();
  const { addCyberSourceScripts } = useCybersourceService();
  const { isLoading: isLoadingCaptchaFlag } = useSingleFlag("PD_CAPTCHA_MTCAPTCHA");

  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [captchaKey, setCaptchaKey] = useState(0);

  const captchaName = useMemo(
    () => `mtcaptcha-checkout-card-${captchaKey}`,
    [captchaKey]
  );

  const setIsCaptchaVerifiedCallback = useCallback((value: boolean) => {
    setIsCaptchaVerified(value);
  }, []);

  useCaptcha({
    setIsVerified: setIsCaptchaVerifiedCallback,
    captchaName,
  });

  const incrementCaptchaKey = useCallback(() => {
    setCaptchaKey((prev) => prev + 1);
  }, []);

  const resetCaptcha = useCallback(() => {
    setIsCaptchaVerified(false);
    if ((window as any)?.mtcaptcha?.resetUI) {
      (window as any).mtcaptcha.resetUI(captchaName);
    }
    incrementCaptchaKey();
  }, [captchaName, incrementCaptchaKey]);

  const {
    isLoading,
    isDisabled,
    errorType,
    dismissError,
    register,
    handleSubmit,
    errors,
    setValue,
    watch,
    trigger,
    clearErrors,
  } = useCheckoutCardForm({
    navigate,
    captchaName,
    isCaptchaVerified,
    resetCaptcha,
  });

  const goBack = () => navigate(-1);

  useEffect(() => {
    addCyberSourceScripts();
  }, []);

  return (
    <CheckoutCardView
      register={register}
      handleSubmit={handleSubmit}
      errors={errors}
      goBack={goBack}
      isDisabled={isDisabled}
      errorType={errorType}
      dismissError={dismissError}
      isLoading={isLoading}
      setValue={setValue}
      watch={watch}
      trigger={trigger}
      clearErrors={clearErrors}
      captchaName={captchaName}
      isCaptchaVerified={isCaptchaVerified}
      isLoadingCaptchaFlag={isLoadingCaptchaFlag}
      resetCaptcha={resetCaptcha}
    />
  );
}
